export const menu = {
    label: 'Guichê FE',
    icon: 'pi pi-id-card',
    rules: ['CHECKINS-GUICHE-01'],
    items: [
        {
            label: 'Painel TV',
            icon: 'pi pi-fw pi-desktop',
            url: '#/checkins/guiche/painel-tv',
            target: '_blank',
        },
        {
            label: 'Atendimento',
            icon: 'pi pi-fw pi-users',
            url: '#/checkins/guiche/atendente',
            target: '_blank',
        },
        {
            label: 'Cadastro',
            icon: 'pi pi-fw pi-user-plus',
            url: '#/checkins/guiche/cadastro',
            target: '_blank',
            rules: ['CHECKINS-GUICHE-01'],
        },
    ],
};

export default menu;
